module.exports = __webpack_public_path__ + "static/media/room13NorthWall.b59082fb.jpg";